import { baseAPIRequest } from 'utilities/http';

async function setPostalCode (postalCode) {
	
	try {

		const response = await baseAPIRequest({
			url: '/api/product-shipping/postal-code/',
			data: { PostalCode: postalCode },
			params: { method: 'POST' }
		});

		return response;

	} catch (error) {

		console.log(error);

	}

}

export default setPostalCode;
